export function sessionButtonSx(extra?: object) {
  return {
    minHeight: 52,
    borderRadius: 1.5,
    textTransform: 'none' as const,
    fontSize: '1rem',
    fontWeight: 500,
    ...extra,
  }
}
